module.exports = __webpack_public_path__ + "img/ecdc-logo-white.af5b7a52.svg";